"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var selected_connection_1 = require("./selected_connection");
var Flights = /** @class */ (function () {
    function Flights(data, roundtripsOnly) {
        this.twoWay = {};
        this.outgoing = {};
        this.returning = {};
        this.flightClasses = [];
        if (!lodash_1.isEmpty(data) && data.importFlightsData) {
            Object.assign(this, data);
        }
        else if (data && !lodash_1.isEmpty(data) && data.openjaw) {
            this.importFlightsData(data, roundtripsOnly);
        }
    }
    Flights.prototype.importFlightsData = function (data, roundtripsOnly) {
        var outgoing = data.outgoing, returning = data.returning, roundtrip = data.roundtrip, openjaw = data.openjaw;
        var list = lodash_1.concat(roundtrip, openjaw, outgoing, returning);
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var conn = list_1[_i];
            switch (conn.flightDirection) {
                case 'RT':
                    this.addTwoWayConnection(conn);
                    break;
                case 'OJ':
                    this.addTwoWayConnection(conn);
                    break;
                case 'O':
                    this.addOutgoingConnection(conn);
                    break;
                case 'R':
                    this.addReturningConnection(conn);
                    break;
            }
            this.addFlightClass(conn, roundtripsOnly);
        }
        return this;
    };
    Flights.prototype.addFlightClass = function (conn, roundtripsOnly) {
        var flightClass = conn.class;
        var flightClassName = conn.className;
        if (roundtripsOnly && (conn.flightDirection === 'O' || conn.flightDirection === 'R')) {
            return;
        }
        var exists = lodash_1.find(this.flightClasses, function (fc) {
            return fc.code === flightClass;
        });
        if (!exists) {
            this.flightClasses.push({
                code: flightClass,
                name: flightClassName
            });
        }
    };
    Flights.prototype.addTwoWayConnection = function (conn) {
        var data = this.twoWay;
        var flightClass = conn.class;
        var airportCode = conn.outgoingFlightCode;
        if (!data[flightClass]) {
            data[flightClass] = {};
        }
        if (!data[flightClass][airportCode]) {
            data[flightClass][airportCode] = [];
        }
        data[flightClass][airportCode].push(conn);
    };
    Flights.prototype.addOutgoingConnection = function (conn) {
        var data = this.outgoing;
        var flightClass = conn.class;
        var airportCode = conn.outgoingFlightCode;
        if (!data[flightClass]) {
            data[flightClass] = {};
        }
        if (!data[flightClass][airportCode]) {
            data[flightClass][airportCode] = [];
        }
        data[flightClass][airportCode].push(conn);
    };
    Flights.prototype.addReturningConnection = function (conn) {
        var data = this.returning;
        var flightClass = conn.class;
        var airportCode = conn.returnFlightCode;
        if (!data[flightClass]) {
            data[flightClass] = {};
        }
        if (!data[flightClass][airportCode]) {
            data[flightClass][airportCode] = [];
        }
        data[flightClass][airportCode].push(conn);
    };
    // mandatory roundtrip is defined as: has NO oneway flights available
    Flights.prototype.isMandatoryRoundTrip = function () {
        return lodash_1.isEmpty(this.outgoing) && lodash_1.isEmpty(this.returning);
    };
    Flights.prototype.getTwoWayAirConnections = function (flightClass) {
        var twoWayList = lodash_1.concat(lodash_1.values(this.twoWay[flightClass]));
        return twoWayList;
    };
    Flights.prototype.getOutgoingAirConnectionsOnly = function (flightClass) {
        var outgoing = lodash_1.concat(lodash_1.values(this.outgoing[flightClass]));
        return outgoing;
    };
    Flights.prototype.getReturningAirConnectionsOnly = function (flightClass) {
        var returning = lodash_1.concat(lodash_1.values(this.returning[flightClass]));
        return returning;
    };
    Flights.prototype.getOutgoingAirConnections = function (flightClass, withTwoWay) {
        if (withTwoWay === void 0) { withTwoWay = true; }
        var list = lodash_1.concat(lodash_1.values(this.outgoing[flightClass]));
        if (withTwoWay) {
            var twoWayList = lodash_1.concat(lodash_1.values(this.twoWay[flightClass]));
            list = lodash_1.concat(twoWayList, list);
        }
        return list;
    };
    Flights.prototype.getOutgoingAirports = function (flightClass, withTwoWay, roundtripsOnly) {
        if (withTwoWay === void 0) { withTwoWay = true; }
        if (roundtripsOnly === void 0) { roundtripsOnly = false; }
        var list = [];
        if (!roundtripsOnly) {
            list = this.getOutgoingAirConnections(flightClass, withTwoWay);
        }
        else {
            list = this.getTwoWayAirConnections(flightClass);
        }
        var filtered = lodash_1.filter(lodash_1.flatten(list), function (conn) {
            return conn.outgoingFlightCode && conn.outgoingFlight.segments;
        });
        var mappings = lodash_1.map(lodash_1.flatten(filtered), function (conn) {
            return {
                code: conn.outgoingFlightCode,
                name: conn.outgoingFlight.segments[0].departureAirportName
            };
        });
        return lodash_1.uniqBy(mappings, function (airport) {
            return airport.code;
        });
    };
    Flights.prototype.getReturningAirConnections = function (flightClass, withTwoWay, outCode, roundtripsOnly) {
        if (roundtripsOnly === void 0) { roundtripsOnly = false; }
        var list = [];
        if (outCode && outCode !== 'NOFLIGHT') {
            if (this.isMandatoryRoundTrip()) {
                if (this.twoWay && this.twoWay[flightClass] && this.twoWay[flightClass][outCode]) {
                    list = this.twoWay[flightClass][outCode];
                }
            }
            else {
                if (this.outgoing[flightClass] && this.outgoing[flightClass][outCode]) {
                    if (withTwoWay && this.twoWay && this.twoWay[flightClass] && this.twoWay[flightClass][outCode]) {
                        list = this.twoWay[flightClass][outCode];
                    }
                    if (!roundtripsOnly) {
                        list = lodash_1.flatten(lodash_1.concat(list, lodash_1.values(this.returning[flightClass])));
                    }
                    else {
                        list = lodash_1.flatten(list);
                    }
                }
                else {
                    if (withTwoWay && this.twoWay && this.twoWay[flightClass] && this.twoWay[flightClass][outCode]) {
                        list = this.twoWay[flightClass][outCode];
                    }
                    else {
                        if (!roundtripsOnly) {
                            list = lodash_1.flatten(lodash_1.concat(list, lodash_1.values(this.returning[flightClass])));
                        }
                        else {
                            list = lodash_1.flatten(list);
                        }
                        // list = flatten(concat(list, values(this.returning[flightClass])))
                    }
                }
            }
        }
        else {
            if (this.isMandatoryRoundTrip()) {
                list = lodash_1.flatten(lodash_1.values(this.twoWay[flightClass]));
            }
            else {
                if (withTwoWay && outCode !== 'NOFLIGHT') {
                    if (!roundtripsOnly) {
                        list = lodash_1.flatten(lodash_1.concat(lodash_1.values(this.twoWay[flightClass]), lodash_1.values(this.returning[flightClass])));
                    }
                    else {
                        list = lodash_1.flatten(lodash_1.values(this.twoWay[flightClass][outCode]));
                    }
                }
                else {
                    if (!roundtripsOnly) {
                        list = lodash_1.flatten(lodash_1.values(this.returning[flightClass]));
                    }
                    else {
                        list = lodash_1.flatten(lodash_1.values(this.twoWay[flightClass][outCode]));
                    }
                }
            }
        }
        return list;
    };
    Flights.prototype.getReturningAirports = function (flightClass, withTwoWay, outCode, roundtripsOnly) {
        if (roundtripsOnly === void 0) { roundtripsOnly = false; }
        var list = [];
        list = this.getReturningAirConnections(flightClass, withTwoWay, outCode, roundtripsOnly);
        var filtered = lodash_1.filter(list, function (conn) {
            return conn && conn.returnFlightCode && conn.returnFlight;
        });
        var mappings = lodash_1.map(filtered, function (conn) {
            return {
                code: conn.returnFlightCode,
                name: lodash_1.last(conn.returnFlight.segments).arrivalAirportName
            };
        });
        return lodash_1.uniqBy(mappings, function (airport) {
            return airport.code;
        });
    };
    Flights.prototype.getSelectedConnection = function (flightClass, outCode, retCode) {
        if ((outCode || outCode === '') && retCode && (outCode !== 'NOFLIGHT' && retCode !== 'NOFLIGHT')) {
            var twoWay = null;
            if (this.twoWay[flightClass] && this.twoWay[flightClass][outCode]) {
                twoWay = lodash_1.find(this.twoWay[flightClass][outCode], function (conn) {
                    return conn && conn.returnFlightCode === retCode;
                });
            }
            if (twoWay) {
                return new selected_connection_1.SelectedConnection([twoWay]);
            }
            else if (this.outgoing[flightClass] && this.outgoing[flightClass][outCode] &&
                this.returning[flightClass] && this.returning[flightClass][retCode]) {
                var out = this.outgoing[flightClass][outCode][0];
                var ret = this.returning[flightClass][retCode][0];
                return new selected_connection_1.SelectedConnection([out, ret]);
            }
            else if (!outCode && this.returning[flightClass] &&
                this.returning[flightClass][retCode]) {
                var ret = this.returning[flightClass][retCode][0];
                return new selected_connection_1.SelectedConnection([ret]);
            }
            else {
                return null;
            }
        }
        else if ((retCode || retCode === '') && outCode && (outCode !== 'NOFLIGHT' && retCode !== 'NOFLIGHT')) {
            var twoWay = null;
            if (this.twoWay[flightClass] && this.twoWay[flightClass][outCode]) {
                twoWay = lodash_1.find(this.twoWay[flightClass][outCode], function (conn) {
                    return conn && conn.returnFlightCode === retCode;
                });
            }
            if (twoWay) {
                return new selected_connection_1.SelectedConnection([twoWay]);
            }
            else if (this.outgoing[flightClass] && this.outgoing[flightClass][outCode] &&
                this.returning[flightClass] && this.returning[flightClass][retCode]) {
                var out = this.outgoing[flightClass][outCode][0];
                var ret = this.returning[flightClass][retCode][0];
                return new selected_connection_1.SelectedConnection([out, ret]);
            }
            else if (!retCode && this.outgoing[flightClass] &&
                this.outgoing[flightClass][outCode]) {
                var out = this.outgoing[flightClass][outCode][0];
                return new selected_connection_1.SelectedConnection([out]);
            }
            else {
                return null;
            }
        }
        else if (outCode && outCode !== 'NOFLIGHT' &&
            this.outgoing[flightClass] && this.outgoing[flightClass][outCode]) {
            var out = this.outgoing[flightClass][outCode][0];
            return new selected_connection_1.SelectedConnection([out]);
        }
        else if (retCode && retCode !== 'NOFLIGHT' &&
            this.returning[flightClass] && this.returning[flightClass][retCode]) {
            var ret = this.returning[flightClass][retCode][0];
            return new selected_connection_1.SelectedConnection([ret]);
        }
        else {
            return null;
        }
    };
    return Flights;
}());
exports.Flights = Flights;
//# sourceMappingURL=flights.js.map